import type { RouteObject } from 'react-router';
import { DeadlinesBoardPage } from './pages/DeadlinesBoardPage';

export const DEADLINE_ROUTES: RouteObject[] = [{ path: 'deadlines', element: <DeadlinesBoardPage /> }];
